export default class Faturamento {

    constructor(resource) {
        this._resource = resource('FaturamentoRelatorio_supo');
    }

    getFaturamento(codbco, referencia) {
        return this._resource
            .get(
                {
                    codbco: codbco,
                    referencia: referencia
                })
            .then(res => res.bodyText
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getWhats(cod_contrato, fone, referencia) {
        return this._resource
            .get(
                {
                    cod_contrato: cod_contrato,
                    fone: fone,
                    referencia: referencia
                })
            .then(res => res.bodyText
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getDistrib(referencia) {
        return this._resource
            .get(
                {
                    referencia: referencia,
                })
            .then(res => res.bodyText
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getValores(referencia,raux1,raux2,raux3) {
        return this._resource
            .get(
                {
                    referencia: referencia,
                    raux1: raux1,
                    raux2: raux2,
                    raux3: raux3,
                })
            .then(res => res.bodyText
                , err => {
                    throw new Error(err.statusText)
                });
    }

}